// Modify this import as per your file structure
import {
  RightChevronWrapper,
  SettingsIconWrapper,
  SettingsLabel,
  SettingsRowContainer,
  SettingsRowContent,
  SubLabel,
} from "./settingsRow.styled";
import { SettingsRowProps } from "./settingsRow.type";

import { ReactComponent as RightChevron } from "@assets/images/chevrons/chevron-right.svg";

const SettingsRow = ({ label, icon, subLabel, onClick }: SettingsRowProps) => {
  return (
    <SettingsRowContainer onClick={onClick}>
      <SettingsRowContent>
        <SettingsIconWrapper>{icon}</SettingsIconWrapper>
        <SettingsLabel>{label}</SettingsLabel>
      </SettingsRowContent>
      <RightChevronWrapper>
        {subLabel && <SubLabel>{subLabel}</SubLabel>}
        <RightChevron />
      </RightChevronWrapper>
    </SettingsRowContainer>
  );
};

export { SettingsRow };
